import React, { useMemo } from 'react';
import { HStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography';

import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { PortfolioHeaderButtons } from '@/components/Portfolio/PortfolioHeaderButtons';

export function PortfolioHeader() {
  const { isPhone, isPhoneLandscape } = useBreakpoints();
  const showMobileLayout = useMemo(() => isPhone ?? isPhoneLandscape, [isPhone, isPhoneLandscape]);
  return (
    <HStack justifyContent="space-between" alignItems="flex-start" gap={5}>
      <HStack alignItems="center">
        <Text font="title1" as="h1">
          Positions
        </Text>
      </HStack>
      <HStack alignItems="center" justifyContent="space-between">
        {!showMobileLayout && <PortfolioHeaderButtons />}
      </HStack>
    </HStack>
  );
}
